<template>
  <div class="reject">
    <i class="el-icon-error text-5xl" style="color: #e34152"></i>
    <div class="reject__title">短信审核已拒绝</div>
    <div class="reject__introduce">请按照要求修改后重新提交审核。</div>
    <div class="reject__reason">拒绝原因：{{ commentCpd }}</div>
    <div class="reject__btns">
      <el-button type="primary" @click="toEditFun">去修改问卷</el-button>
      <el-button type="primary" :disabled="isDisabledBtnCpd" @click="openChangeDialogFun">重新提交审核</el-button>
      <el-button type="text" @click="openRefundDialogFun">暂不发送短信，退款</el-button>
    </div>

    <el-dialog title="问卷变更审核" :visible.sync="changeDialogVisible" width="30%">
      <div>由于您的问卷已开启短信发布，为保证问卷内容合规，需提交审核并通过后，本次问卷修改方才正式生效。</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAuditFun">提交审核</el-button>
      </span>
    </el-dialog>

    <el-dialog title="群发短信退款" :visible.sync="refundDialogVisible" width="30%">
      <div class="content">
        <div><span>已支付金额:</span>{{ moneyCpd }}元</div>
        <div><span>退款金额:</span>{{ moneyCpd }}元</div>
        <div>退款后将取消本次群发短信发送</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="refundDialogVisible = false">取消退款</el-button>
        <el-button type="primary" @click="confirmRefundFun">确认退款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GlobalConfig from '@/global/config'
import { submitAuditH } from '@/api/wenjuan/wjquestion'
import { refundSmsH } from '@/api/wenjuan/sample_new'
export default {
  inject: {
    source: {
      default: () => ({})
    },
    nextStep: {
      default: null
    }
  },
  data() {
    return {
      refundDialogVisible: false,
      changeDialogVisible: false
    }
  },
  computed: {
    ...mapState({
      versionId: state => state.survey.versionId
    }),
    isDisabledBtnCpd() {
      if (this.versionId === this.source.versionId) {
        return true
      }
      return false
    },
    moneyCpd() {
      return this.source.money
    },
    commentCpd() {
      return this.source.comment
    }
  },
  methods: {
    toEditFun() {
      this.$router.push({
        path: `/survey/${GlobalConfig.getSurveyId()}/edit`
      })
    },
    openChangeDialogFun() {
      this.changeDialogVisible = true
    },
    submitAuditFun() {
      const { freezesNo, recordId, money } = this.source
      submitAuditH({
        surveyId: GlobalConfig.getSurveyId(),
        sensitive: freezesNo + '@' + recordId + '@' + money,
        examineType: 1
      }).then(res => {
        if (res.code === 1) {
          this.$message({
            message: '提交审核失败',
            type: 'error'
          })
          return
        }
        this.$message({
          message: '提交审核成功',
          type: 'success'
        })
        this.changeDialogVisible = false
        this.nextStep(3)
      })
    },
    openRefundDialogFun() {
      this.refundDialogVisible = true
    },
    confirmRefundFun() {
      this.refundDialogVisible = false
      const { recordId, freezesNo } = this.source
      refundSmsH({ recordId, freezesNo }).then(res => {
        if (res.code === 1) {
          this.$message({
            type: 'error',
            message: '退款失败'
          })
          return
        }
        this.$message({
          type: 'success',
          message: '退款成功'
        })
        this.nextStep(0)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  &__header {
    height: 48px;
    background: #f5f7fa;
    border-radius: 4px 4px 0 0;
    padding: 0 16px;
  }

  &__title {
    height: 22px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 18px;
    color: rgba($color: #000000, $alpha: 0.85);
    text-align: left;
    line-height: 22px;
  }
  &__body {
    padding: 16px;

    div {
      line-height: 20px;
    }
  }
  &__footer {
    border-top: 1px solid rgba($color: #000000, $alpha: 0.1);
    padding-top: 17px;
    padding-bottom: 16px;
  }
}

.content {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);

  div {
    line-height: 22px;
    height: 22px;
  }

  & div:nth-child(1) {
    margin-bottom: 12px;
  }

  & div:nth-child(2) {
    margin-bottom: 4px;
  }

  & div:nth-child(3) {
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 12px;
    color: #e8a31b;
    margin-left: 84px;
  }

  span {
    display: inline-block;
    width: 85px;
    text-align: right;
  }
}

.reject {
  margin-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__title {
    margin-top: 8px;
    height: 22px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }

  &__introduce {
    margin-top: 12px;
    height: 22px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.65);
    line-height: 22px;
  }

  &__reason {
    margin-top: 24px;
    height: auto;
    width: 392px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: rgba($color: #000000, $alpha: 0.85);
    text-align: center;
    line-height: 22px;
  }

  &__btns {
    margin-top: 40px;
  }
}
</style>
